import React, { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Box, Label, Button } from 'fw/components'
import { ContentBody } from 'areas/shared/components';
import * as FormManager from 'fw/forms/form/FormManager';
import * as Notifications from 'fw/globals/Notifications';
import * as API from 'modules/app/API';
import APICall from 'fw/system/API';
import * as Modals from 'fw/globals/Modals';
import { faCheck, faCreditCard } from '@fortawesome/free-solid-svg-icons';
import { faCcPaypal, faCcStripe, faCcAmex, faCcDiscover, faCcMastercard, faCcVisa } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { PayPalScriptProvider, PayPalButtons, usePayPalScriptReducer } from "@paypal/react-paypal-js";
import Loading from 'layouts/public/loading/Loading';
import { TextBox } from 'fw/forms';

library.add(faCheck, faCreditCard, faCcPaypal, faCcStripe, faCcAmex, faCcDiscover, faCcMastercard, faCcVisa);

const maxPaypalButtonWait = 4;

class PreQualificationPayment extends React.Component {

    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    initialState = () => {
        return {
            loading: true,
            title: "",
            busy: false,
			codeValidated: false,
			discountCodeValid: false,
			discountCodeApplied: null,
			discountAmountApplied: null,
            form: {
                activeManagement: true,
                capitalContribution: true,
                abilityToPerform: true,
                amount: null,
				discountCode: null
            }
        };
    }

    componentDidMount() {
        this.get(this.props.match.params.vobKey, this.props.match.params.vobFeinKey);
    }

    createOrder(data, actions) {
        const currency = "USD";

		return actions.order.create({
			intent: "CAPTURE",
			purchase_units: [{
				description: "NVBDC Pre-Qualification fee for Company FEIN " + this.state.form.vobFein,
                reference_id: this.state.form.certificationId,
				business: this.state.form.merchantId,
				amount: {
					currency_code: currency,
					value: this.state.form.amount - this.state.discountAmountApplied,
                    breakdown: {
                        item_total: { 
                            currency_code: currency, 
                            value: this.state.form.amount - this.state.discountAmountApplied
                        }
                    }
				},
                items: [{
                      name: this.state.form.certificationId,
                      unit_amount: {
                        currency_code: currency,
                        value: this.state.form.amount - this.state.discountAmountApplied
                      },
                      quantity: 1
                }],
			}]
		});
	}

	async onApprove(data, actions) {
		await actions.order.capture();
        const returnUrl = window.location.origin + '/certification/preQualificationPaymentAccepted/' + this.props.match.params.vobKey;
        
        this.setState((prevState) => ({
            busy: true
        }));

        setTimeout(() => {
            window.location.href = returnUrl;
        }, 2000);		
	}

    onShippingChange(e) {
    }

    onError(error) {
		console.log(error);
        Notifications.error("An error occurred trying to process your payment.");
	}

    checkPaypalButton(waitLimit) {
        let allWithClass = Array.from(
            document.getElementsByClassName('paypal-buttons')
        );

        if (allWithClass.length <= 0) {
            if (waitLimit > 0)
                setTimeout(() => this.checkPaypalButton(waitLimit-1), 1000);
            else
                window.location.reload();
        }
    }

	applyDiscountCodeRequest() {
		return {
			certificationId: this.state.form.certificationId,
			discountCode: this.state.form.discountCode,
			feeAmount: this.state.form.amount
		};
	}

	applyDiscountCode = () => {
		const me = this;
		const rq = this.applyDiscountCodeRequest();
		const url = API.DiscountCode.url('/discountCodeSetup/applyDiscountCode');

		new APICall().post(url, rq, {
			success: (r) => {
				Notifications.success(r.message);
				me.setState({ 
					codeValidated: true,
					discountCodeValid: true,
					discountAmountApplied: r.data.discountAmountApplied,
					discountCodeApplied: rq.discountCode
				});
			},
			error: r => {
				me.setState({ 
					codeValidated: true,
					discountCodeValid: false,
					discountAmountApplied: null,
					discountCodeApplied: null
				});
				Notifications.error(r.error.errorMessage);
			}
		})
	}

	unapplyDiscountCodeRequest() {
		return {
			certificationId: this.state.form.certificationId,
		};
	}

	unapplyDiscountCode = () => {
		const rq = this.unapplyDiscountCodeRequest();
		const url = API.DiscountCode.url('/discountCodeSetup/unapplyDiscountCode');

		new APICall().post(url, rq)
	}

	submitNoPaymentRequest() {
		return {
			certificationId: this.state.form.certificationId,
			applicationFee: this.state.form.amount
		};
	}

	submitNoPayment = () => {
		const rq = this.submitNoPaymentRequest();
		API.Certification.post('/certificationSetup/savePreQualificationNoPayment', rq,
            {
                success: (r) => {
                    Notifications.success(r.message);
                    this.props.history.push(r.data.isRenewal
                        ? '/certification/renewalOneSheet/' + r.data.certificationKey
                        : '/certification/certification/' + r.data.stepCode + '/' + r.data.certificationKey);
                },
                error: (r) => {
                    Notifications.error(r.error.errorMessage);
                }
            });
	}

	handleApplyDiscountCode = () => {
		var me = this;

		if (this.state.discountCodeApplied !== null) {
			if (this.state.form.discountCode !== this.state.discountCodeApplied) {
				Modals.confirm("Do you want to unapply the previously applied Discount Code?",
					function () {
						me.applyDiscountCode();
					},
					function () {
						return;
					}
				);
			}
			else{
				Notifications.success("The Discount Code was already applied");
			}
		}
		else {
			me.applyDiscountCode();
		}
	}

	handleDiscountCodeChange = (value) => {
		this.setState((prevState) => {
			return ({
				form: {
					...prevState.form,
					discountCode: value
				}
			});
		});
	}

    get = (vobKey, vobFeinKey) => {
        const me = this;

        var rq = {
            vobKey: vobKey !== undefined ? vobKey : null,
            vobFeinKey: vobFeinKey !== undefined ? vobFeinKey : null
        };

        API.Certification.get('/certificationSetup/getPreQualificationPayment', rq,
            {
                success: (r) => {
                    this.setState((prevState, props) => ({
                        loading: false,
                        form: r.data
                    }));
                    this.checkPaypalButton(maxPaypalButtonWait);
                },
                error: (r) => {
                    if (r.data && r.data.rowVersion) {
                        Modals.confirm(r.error.errorMessage,
                            function () {
                                me.save(r.data.rowVersion);
                            },
                            function () {
                                me.get(r.data.vobKey);
                            }
                        );
                    } else {
                        Notifications.error(r.error.errorMessage);
                    }
                }
            });
    }

    save = (complete) => {
        const form = this.state.form;
        const me = this;

        let rq = {
            certificationId: form.certificationId,
            vobId: form.vobId,
            vobFein: form.vobFein,
            activeManagement: form.activeManagement,
            capitalContribution: form.capitalContribution,
            abilityToPerform: form.abilityToPerform,
            activeManagementStorageToken: form.activeManagementStorageToken,
            activeManagementFileName: form.activeManagementFileName,
            capitalContributionStorageToken: form.capitalContributionStorageToken,
            capitalContributionFileName: form.capitalContributionFileName,
            abilityToPerformStorageToken: form.abilityToPerformStorageToken,
            abilityToPerformFileName: form.abilityToPerformFileName,
            annualSalesTypeId: form.annualSalesTypeId,
			discountCode: form.discountCode,
            complete: complete
        };

        API.Certification.post('/certificationSetup/savePreQualification', rq,
            {
                success: (r) => {
                    Notifications.success(r.message);
                    FormManager.reset();

                    if (complete) {
                        this.props.history.push('/certification/certification/' + r.data.stepCode + '/' + r.data.certificationKey);
                        return;
                    }
                    me.get(r.data.vobKey);
                },
                error: (r) => {
                    if (r.data && r.data.rowVersion) {
                        Modals.confirm(r.error.errorMessage,
                            function () {
                                me.save(r.data.rowVersion);
                            },
                            function () {
                                me.get(r.data.vobKey);
                            }
                        );
                    } else {
                        Notifications.error(r.error.errorMessage);
                    }
                }
            });
    }

    onChange = (form, callback) => {
        this.setState({ form }, callback);
    }

    cancel = () => {
		this.unapplyDiscountCode();
        this.props.history.push('/');
    }

    handlePrevious = () => {
        this.props.history.push('/certification/prequalification/' + this.props.match.params.vobKey);
    }

    handleCancel = () => {
        const me = this;

        FormManager.checkUnsavedChanges(function () {
            me.cancel();
        })
    }

    render() {
        // This values are the props in the UI
        const currency = "USD";
        const style = { "layout" : "vertical" };
        let clientId = this.state.form.paypalClientId;
        let amount = this.state.form.amount - this.state.discountAmountApplied;

        // Custom component to wrap the PayPalButtons and handle currency changes
        const ButtonWrapper = ({ currency, showSpinner }) => {
            // usePayPalScriptReducer can be use only inside children of PayPalScriptProviders
            // This is the main reason to wrap the PayPalButtons in a new component
            const [{ options, isPending }, dispatch] = usePayPalScriptReducer();

            useEffect(() => {
                dispatch({
                    type: "resetOptions",
                    value: {
                        ...options,
                        currency: currency,
                    },
                });
            }, [currency, showSpinner]);


            return (
                <React.Fragment>
                    { (showSpinner && isPending)
                    ?
                        <Loading /> 
                    :
                        <PayPalButtons
                            style={style}
                            disabled={false}
                            forceReRender={[amount, currency, style]}
                            fundingSource={undefined}
                            createOrder={(data, actions) => this.createOrder(data, actions)}
                            onApprove={(data, actions) => this.onApprove(data, actions)}
                            onError={(err) => this.onError(err)}
                            onShippingChange={(v) => this.onShippingChange(v)}
                        />
                    }
                </React.Fragment>
            );
        }

        return (
            <ContentBody>
                <Row><Col>&nbsp;</Col></Row>
                <Row>
                    <Col md={4}></Col>
                    <Col className="col-xs-1-10 text-center">
                        <p style={{ fontSize: '13px' }}>
                            Pre-Qualification
                        </p>
                        {this.state.form.certificationStatusCode === 'STR' ?
                            <React.Fragment>
                                <FontAwesomeIcon icon={['fas', 'check']} size="3x" style={{ color: '#FF9900' }} className="my-icon" />
                                <p style={{ fontSize: '13px' }}>
                                    In Progress
                                </p>
                            </React.Fragment>
                            : this.state.form.certificationStatusCode === 'PRE' ?
                                <React.Fragment>
                                    <FontAwesomeIcon icon={['fas', 'check']} size="3x" style={{ color: '#2A77E4' }} className="my-icon" />
                                    <p style={{ fontSize: '13px' }}>
                                        Completed
                                    </p>
                                </React.Fragment>
                                :
                                <React.Fragment>
                                    <FontAwesomeIcon icon={['fas', 'check']} size="3x" style={{ color: 'darkslategray' }} className="my-icon" />
                                    <p style={{ fontSize: '13px' }}>
                                        Not Started
                                    </p>
                                </React.Fragment>
                        }
                    </Col>
                    <Col md={2}></Col>
                    <Col className="col-xs-1-10 text-center">
                        <p style={{ fontSize: '13px' }}>
                            <strong>Payment</strong>
                        </p>
                        <FontAwesomeIcon icon={['fas', 'credit-card']} size="3x" style={{ color: 'darkslategray' }} />
                        <p style={{ fontSize: '13px' }}>
                            <strong>Not Started</strong>
                        </p>
                    </Col>
                    <Col md={4}></Col>
                </Row>
                <ContentBody>
                    <Row>
                        <Col md={12}>
                            {this.state.busy ?
                                <Loading />
                            :
                                <Box>
                                    <Row>
                                        <Col md={12}>
											{this.state.discountCodeValid &&
												<React.Fragment>
													<p style={{ fontSize: '20px' }}>
														A Fee of <strong>${this.state.form.amount}</strong> is required. 
													</p>
													<p style={{ fontSize: '20px' }}>
														A Discount of <strong>${this.state.discountAmountApplied}</strong> will be applied
													</p>
												</React.Fragment>
											}
											<p style={{ fontSize: '20px' }}>
                                                A Payment Fee of <strong>${this.state.form.amount - this.state.discountAmountApplied}</strong> is required to Submit your Application
                                            </p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={12}>
                                            <hr />
                                        </Col>
                                    </Row>
									{["CER", "REN", "REC"].includes(this.state.form.certificationTypeCode) &&
										<React.Fragment>
											<Row>
												<Col md={12}>
													<Label>If you have a Discount Code please enter it and click Apply</Label>
												</Col>
											</Row>
											<Row style={{ marginTop: '5px' }}>
												<Col md={2}>
													<TextBox
														id="discountCode"
														name="discountCode"
														placeholder="Enter Discount Code"
														onChange={this.handleDiscountCodeChange}
														maxLength={20} />
												</Col>
												<Col md={1}>
													<Button id="btnApplyDiscountCode" bsStyle="primary" onClick={this.handleApplyDiscountCode} style={{ marginLeft: '-20px' }}>Apply</Button>
												</Col>
												<Col md={6}>
													{this.state.codeValidated && this.state.discountCodeValid &&
														<React.Fragment>
															<FontAwesomeIcon icon={['fas', 'check']} size="2x" style={{ color: 'green', textAlign: 'left', marginLeft: '-80px', marginTop: '3px' }} className="my-icon" />
															<b style={{ color: 'green', marginLeft: '5px' }}>The code is valid</b>
														</React.Fragment>
													}
													{this.state.codeValidated && !this.state.discountCodeValid && 
														<React.Fragment>
															<FontAwesomeIcon icon={['fas', 'times']} size="2x" style={{ color: 'red', textAlign: 'left', marginLeft: '-80px', marginTop: '3px' }} className="my-icon" />
															<b style={{ color: 'red', marginLeft: '5px' }}>The code is NOT valid</b>
														</React.Fragment>
													}
												</Col>
											</Row>
										</React.Fragment>
									}
									{this.state.form.amount - this.state.discountAmountApplied > 0 &&
                                    <React.Fragment>
										<Row style={{ marginTop: '10px' }}>
											<Col md={12}>
												<Label>Please select your Payment Type below</Label>
												<br />
												<br />
											</Col>
										</Row>
										<Row>
											<Col md={6}>
												<Row>
													<Col md={12} className="text-center">
														{ clientId ?
															<div style={{ maxWidth: "750px", minHeight: "200px" }}>
																<PayPalScriptProvider
																	options={{
																		"client-id": clientId,
																		locale: "en_US",
																		"disable-funding": "credit",
																		components: "buttons",
																		currency: currency
																	}}
																>
																	<ButtonWrapper
																		currency={currency}
																		showSpinner={true}
																	/>
																</PayPalScriptProvider>
															</div>
														: null }
													</Col>
												</Row>
											</Col>
											<Col md={6}>
												<div style={{ padding: "10px", backgroundColor: "#9FC5F8" }}>
													<p>To pay by Debit or Credit Card you do not need a PayPal account.</p>
													<p>To pay by check (EFT) you must have a PayPal account.</p>
													<p>
														NVBDC no longer accepts paper checks and encourages you to save a tree and use EFT
													</p>
												</div>
											</Col>
										</Row>
									</React.Fragment>
									}
									{this.state.codeValidated && this.state.discountCodeValid && this.state.form.amount - this.state.discountAmountApplied === 0 &&
										<Row style={{ marginTop: '10px' }}>
											<Col md={12}>
												<Label>Please press the button below to Submit your Application</Label>
												<br />
												<br />
												<Button id="btnSubmitNoPayment" bsStyle="success" onClick={this.submitNoPayment}>Submit</Button>
											</Col>
										</Row>
									}
                                    <Row>
                                        <Col md={12}>
                                            <br />
                                        </Col>
                                    </Row>
                                    <Row className="text-right">
                                        <Col md={12}>
                                            <Button type="button" id="btnNext" title="Previous step" bsStyle="default"
                                                onClick={() => this.handlePrevious()}>
                                                Previous
                                            </Button>
                                            &nbsp;&nbsp;
                                            <Button type="button" id="btnCancel" bsStyle="danger" title="Cancel"
                                                onClick={() => this.handleCancel()}>
                                                Cancel
                                            </Button>
                                        </Col>
                                    </Row>
                                </Box>
                            }
                        </Col>
                    </Row>
                </ContentBody>
            </ContentBody>
        )
    }
}

export default PreQualificationPayment;



// WEBPACK FOOTER //
// ./src/areas/certification/preQualification/PreQualificationPayment.js